import React from 'react';
import { Card, Steps, Row, Col } from 'antd';
import { connect } from 'dva';
import styles from './Index.less';
import Step1 from './Step1/Index.js';
import Step2 from './Step2/Index.js';
import Step3Scan from './Step3-Scan/Index.js';
import Step3Notification from './Step3-Notification/Index.js';
import Step4Notification from './Step4-Notification/Index.js';
import StepSelectSchool from './StepSelectSchool/Index.js';

const { Step } = Steps;

@connect(({ operationChargeItemPublishChargeItemSteps, AddressBook }) => ({
  current: operationChargeItemPublishChargeItemSteps.currentStep,
  chargeTarget: AddressBook.chargeTarget,
  chargeItemMode: operationChargeItemPublishChargeItemSteps.chargeItemMode,
}))
export default class PublishChargeItemSteps extends React.Component {
  componentWillUnmount() {
    this.props.dispatch({ type: 'operationChargeItemPublishChargeItemSteps/resetState' });
  }

  render() {
    const { current, chargeItemMode } = this.props;

    let steps = [
      {
        key: 0,
        title: '选择学校',
        component: <StepSelectSchool />,
      },
      {
        key: 1,
        title: '选择商品',
        component: <Step1 />,
      },
      {
        key: 2,
        title: '收费设置',
        component: <Step2 />,
      },
    ];

    if (chargeItemMode === 'SCAN') {
      steps = steps.concat([
        {
          key: 3,
          title: '发布',
          component: <Step3Scan />,
        },
      ]);
    } else if (chargeItemMode === 'NOTIFICATION') {
      steps = steps.concat([
        {
          key: 3,
          title: '选择缴费对象',
          component: <Step3Notification />,
        },
        {
          key: 4,
          title: '发布',
          component: <Step4Notification />,
        },
      ]);
    }

    return (
      <Card bordered={false} className={styles.root}>
        <Row>
          <Col span={24}>
            <Steps current={current}>
              {steps.map(step => <Step key={step.key} title={step.title} />)}
            </Steps>
          </Col>
        </Row>

        <Row className="content-wrap">
          <Col span={24}>{steps[current].component}</Col>
        </Row>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Index.js